/* Offer countdown and delivery line (Isaac, 20 Oct 2026).
   - [data-hl-countdown]: "Ends in Xd Yh Zm", counts to data-end on the nearest [data-hl-offer-end].
     Everyone sees the same fixed moment. When it passes the element is hidden and nothing restarts.
   - [data-hl-delivery]: "Order within Xh Ym and it ships next business day. Arrives A to B."
     Cutoff data-cutoff o'clock in the data-tz time zone, 5 to 10 business days after dispatch.
     Public holidays are not modelled. */
(function () {
  'use strict';

  function pad(n) { return n; }

  function tickOffer() {
    var now = Math.floor(Date.now() / 1000);
    document.querySelectorAll('[data-hl-offer-end]').forEach(function (el) {
      var end = +el.getAttribute('data-end');
      if (!end) return;
      var rem = end - now;
      if (rem <= 0) { if (!el.hidden) el.hidden = true; return; }
      var c = el.querySelector('[data-hl-countdown]');
      if (c) {
        var txt = 'Ends in ' + Math.floor(rem / 86400) + 'd ' + Math.floor((rem % 86400) / 3600) + 'h ' +
          Math.floor((rem % 3600) / 60) + 'm';
        // write only on change: a write is a DOM mutation, and the observer below listens to those
        if (c.textContent !== txt) c.textContent = txt;
      }
    });
  }

  // Wall clock in a named time zone, as plain numbers.
  function wall(tz, date) {
    var parts = {};
    new Intl.DateTimeFormat('en-AU', {
      timeZone: tz, hour12: false, year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', second: 'numeric'
    }).formatToParts(date).forEach(function (p) { parts[p.type] = p.value; });
    var h = +parts.hour === 24 ? 0 : +parts.hour;
    return { y: +parts.year, m: +parts.month, d: +parts.day, h: h, mi: +parts.minute, s: +parts.second };
  }

  function isBiz(d) { var w = d.getUTCDay(); return w !== 0 && w !== 6; }
  function addDays(d, n) { var x = new Date(d.getTime()); x.setUTCDate(x.getUTCDate() + n); return x; }
  function nextBiz(d) { var x = addDays(d, 1); while (!isBiz(x)) x = addDays(x, 1); return x; }
  function addBiz(d, n) { var x = d; for (var i = 0; i < n; i++) x = nextBiz(x); return x; }
  function fmt(d) {
    return d.toLocaleDateString('en-AU', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' })
      .replace(',', '');
  }

  function tickDelivery() {
    document.querySelectorAll('[data-hl-delivery]').forEach(function (el) {
      var tz = el.getAttribute('data-tz') || 'Australia/Sydney';
      var cutoff = +el.getAttribute('data-cutoff') || 16;
      var w;
      try { w = wall(tz, new Date()); } catch (e) { return; }
      // Local wall clock held in UTC fields so day maths cannot slip on daylight saving.
      var today = new Date(Date.UTC(w.y, w.m - 1, w.d));
      var nowMs = Date.UTC(w.y, w.m - 1, w.d, w.h, w.mi, w.s);
      var orderDay = (isBiz(today) && w.h < cutoff) ? today : nextBiz(today);
      var cutMs = Date.UTC(orderDay.getUTCFullYear(), orderDay.getUTCMonth(), orderDay.getUTCDate(), cutoff, 0, 0);
      var rem = Math.max(0, Math.floor((cutMs - nowMs) / 1000));
      var d = Math.floor(rem / 86400), h = Math.floor((rem % 86400) / 3600), m = Math.floor((rem % 3600) / 60);
      var left = (d > 0 ? d + 'd ' : '') + h + 'h ' + m + 'm';
      var dispatch = nextBiz(orderDay);
      var out = 'Order within ' + left + ' and it ships next business day. Arrives ' +
        fmt(addBiz(dispatch, 5)) + ' to ' + fmt(addBiz(dispatch, 10)) + '.';
      if (el.textContent !== out) el.textContent = out;
      if (el.hidden) el.hidden = false;
    });
  }

  function tick() { tickOffer(); tickDelivery(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tick); else tick();
  setInterval(tick, 20000);
  // quick add and cart drawers insert these nodes later
  // Only react to inserted ELEMENTS that carry our hooks, never to our own text writes.
  var queued = false;
  new MutationObserver(function (muts) {
    if (queued) return;
    for (var i = 0; i < muts.length; i++) {
      var nodes = muts[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (n.nodeType === 1 && (n.matches('[data-hl-delivery],[data-hl-offer-end]') ||
            n.querySelector('[data-hl-delivery],[data-hl-offer-end]'))) {
          queued = true;
          requestAnimationFrame(function () { queued = false; tick(); });
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
